import React from 'react';
//import FormHeader from '~/components/form/form-header';
//import FormFooter from '~/components/form/form-footer';
import { FormGroup } from '~/components/form';
import Modal from '~/components/Modal';
import { FormSelect } from '~/components/form';
import {  MdClose } from 'react-icons/md';
import { useForm } from '~/hooks';
import { TITLES } from '~/util/auth';
import { matchSorter } from 'match-sorter';
import omitBy from 'lodash/omitBy';

const FilterUsers= (props) => {

    const titleOptions = TITLES.map(f => ({
        label: f, value: f
    }));

    let rolesOptions = [];

    /*get distinct role names from current data*/
    const roleNames = props.data.map(f => f.role)
        .filter((value, index, self) => self.indexOf(value) === index);
    rolesOptions = roleNames.filter(f => f.length>0 ).map((f) => ({
        label: f, value: f
    }));

    /*get distinct firm names from current firms in data*/
    const firmNames = props.data.map(f => f.firmname)
        .filter((value, index, self) => self.indexOf(value) === index).sort();
    const firmNameOptions = firmNames.filter(f => f?.length > 0 ).map((f) => ({
        label: f, value: f
    }));

    const {
        state: { values: filters },
        fieldActions,
        formActions
    } = useForm({
        initialState: {
            name: '',
            firmname:  null,
            firmNameOptions: firmNameOptions,
            title:  null,
            titleOptions: titleOptions,
            role:  null,
            roleOptions: rolesOptions,
        },
    });

    const clean = (filters) => {
        return omitBy(filters, (value, key) => value == null || /options/i.test(key));
    };

    const filterData = () => {
        if(filters.firmname === '' && filters.name === '' && filters.role === '' && filters.title.length == 0) {
            props.applyFilter(props.data);
        } else {
            const filtered = applyFilters(props.data, clean(filters));
            props.applyFilter(filtered);
        }
       
        props.onCancel();
    };

    const clearFilters = () => {
        formActions.reset();
        props.applyFilter(props.data);
        props.onCancel();
    };

    return (
        <div>        
            <Modal isModalOpen={props.isModalOpen} preventScroll className='rounded-md bg-white'>
                <section className='w-full h-full flex flex-col items-stretch justify-start'>
                    <header className="border-b-2 text-sm flex items-center justify-between py-2 px-6">
                        <p className="font-semibold">{props.headerTxt}</p>
                        <button 
                            className="py-2 rounded-full"
                            onClick={props.onCancel}
                        >
                            <MdClose size="2em" />
                        </button>
                    </header>
                    <div className='flex items-center justify-center flex-1 p-6'>
                        <div className='grid grid-cols-11 gap-y-4'>
                            <FormGroup
                                inputClassName='w-full mt-2 border-1 border-gray-200 rounded bg-gray-50'
                                labelClassName='text-sm'
                                groupClassName='col-span-5'
                                label='Name'
                                value={filters.name}
                                path='name'
                                {...fieldActions}
                            />
                            <span className='col-span-1' />
                            <FormSelect 
                                options={filters.firmNameOptions}
                                isMulti
                                isSearchable
                                inputClassName='w-full mt-2 border-1 border-gray-200 rounded bg-gray-50'
                                labelClassName='text-sm'
                                groupClassName='col-span-5'
                                label='Firm Name'
                                path='firmname'
                                value={filters.firmname}
                                {...fieldActions}
                            />
                            
                            <FormSelect 
                                options={filters.titleOptions}
                                isMulti
                                inputClassName='w-full mt-2 border-1 border-gray-200 rounded bg-gray-50'
                                labelClassName='text-sm'
                                groupClassName='col-span-5'
                                label='Title'
                                path='title'
                                value={filters.title}
                                {...fieldActions}
                            />
                            <span className='col-span-1' />
                            <FormSelect 
                                options={filters.roleOptions}
                                isMulti
                                inputClassName='w-full mt-2 border-1 border-gray-200 rounded bg-gray-50'
                                labelClassName='text-sm'
                                groupClassName='col-span-5'
                                label='User Role'
                                path='role'
                                value={filters.role}
                                {...fieldActions}
                            />
                            <div className='col-span-11 flex items-center justify-end text-xs'>
                                <button 
                                    className='py-2 px-4 rounded-full border mr-2 focus:outline-none'
                                    onClick={clearFilters}
                                >
                                    Clear Filters
                                </button>
                                <button 
                                    className='py-2 px-4 rounded-full bg-blue-50 text-white focus:outline-none'
                                    onClick={filterData}
                                >
                                    Apply
                                </button>
                            </div>
                        </div>
                    </div>
                </section>
            </Modal>
        </div>
    );
};

const applyFilters = (data = [], filters = {}) => {
    
    const matchers = buildMatchers(filters);

    const filteredData = Object.keys(matchers)
        .reduce(
            (result, filterName) => matchers[filterName](result),
            data
        );

    return filteredData;
};

const opts = (keys) => ({ keys, sorter: d => d });

function buildMatchers (filters = { }) {
    let matchers = {
        name: data => matchSorter(data, filters.name, opts(['name'])),
        firmname: data => matchMultiSelect(data, filters.firmname, ['firmname']),
        title: data => matchMultiSelect(data, filters.title, ['title']),
        role: data => matchMultiSelect(data, filters.role, ['role']),
    };

    return omitBy(matchers, (_, key) => !filters[key]);
}

function matchSelect(data, option, keys) {
    if (!option || !option.value)
        return data;

    const { value } = option;

    return matchSorter(data, value, opts(keys));
}

function matchMultiSelect(data, options, keys) {
    return options.reduce(
        (result, option) => [ ...result, ...matchSelect(data, option, keys) ],
        []
    );
}

export default FilterUsers;